<template>
	<template v-if="templateData.components_data">
		<ViewWrapperComponent :templateData="templateData.components_data" @refresh="refreshComponentData" />
	</template>
	
</template>


<script>

// import { defineComponent } from 'vue'
import ViewWrapperComponent from '@vueapp/components/ViewWrapperComponent.vue'

export default {

	name: 'ViewWrapperView',
	props: ['postSlug', 'postId'],
	components: {
		ViewWrapperComponent
	},
	data() {
		return {
			templateData: {},

		}
	},
	provide() {
		return {
			wrapperView: true,
		}
		
	},
	methods: {
		refreshComponentData() {
			const params = new URLSearchParams(window.location.search),
	            eParams = {}
	        params.forEach((value, name) => {
	            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+]+)$/) ) {
	                eParams[name] = value
	            }
	        });

	        let paramsString = ( new URLSearchParams(eParams) ) .toString()

			// console.log(BRYTER.homeUrl + '/data-view/' + this.postSlug + '/?env=' + BRYTER.envId + '&json')
		    fetch( BRYTER.homeUrl + '/wrapper/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
	      		.then(response => response.json())
	      		.then(data => {
	      			// console.log(data)
	        		this.templateData = data
	        		// this.loading = false
	        		this.defaultTabId = data.default_tab
	        		
	      		})
		},

		
		updateCurrentTabId(value) {
			$cookies.set(this.cookieKey, value, 60 * 60 * 12)
		} 
	},
	computed: {
		
	},
	async beforeMount() {

		this.refreshComponentData()

	},
}

</script>